// import { showAlert, hideAlert } from './alert';
import { apiClient } from '../../utils';
import { uploadMedia, handleError } from '..';
import { UPLOAD_MEDIA_FOREIGN_TYPES } from '../../config';

export const createMenu = async ({ name, icon, url, items, image, siteId }) => {
  try {
    const data = {
      siteID: siteId,
      menu: [
        {
          name,
          url,
          ...(icon ? { icon } : {}),
          ...(items.length ? { items } : {}),
        },
      ],
    };

    const rsp = await apiClient.post('/merchant/menu/addItem', {
      data,
    });

    // the response includes all the mega menu items with the last item being the item that was created.
    const createdItem = rsp.result[rsp.result.length - 1];
    const itemId = createdItem._id;

    if (image instanceof File) {
      const mediaPayload = {
        site: siteId,
        mc: name,
        foreign_id: itemId,
        menuLogo: image,
      };
      await uploadMedia(mediaPayload, { endpoint: '/merchant/media/upload' });
    }

    return;
  } catch (e) {
    handleError(e);
    throw e;
  }
};
